/**
 * Returns 2-letter initials from a display name (e.g. "Jane Doe" → "JD").
 * For 3+ parts, uses first + last (e.g. "Billy Joe Johnson" → "BJ").
 */
export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    const first = parts[0];
    const last = parts[parts.length - 1];
    return (first[0] + last[0]).toUpperCase();
  }
  return parts[0]?.slice(0, 2).toUpperCase() ?? '—';
}
